
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Machine, MachineCreate } from './machine';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Machinetype } from '../machinetype/machinetype';
import { HttpParams } from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export class MachineService {
  machineurl = environment.appURL + "/machines";
  machinetypesurl = environment.appURL + "/machinetypes";

  constructor(private http: HttpClient) { }

  //GET ALL MACHINES WITH LIMIT COUNT 200 (TO ENHANCE PAGE LOAD ON LARGE DATASETS)
  getMachines() {
    return this.http.get<Machine[]>(this.machineurl + "?_limit=200", { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getMachines', [])));
  }

  //GET ALL MACHINES WITH LIMIT COUNT 200 (TO ENHANCE PAGE LOAD ON LARGE DATASETS)
  getMachineByClientID(client : number) {
    return this.http.get<Machine[]>(this.machineurl + "?client=" + client, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getMachines', [])));
  }


  //GET ALL MACHINES WITH LIMIT COUNT 200 (TO ENHANCE PAGE LOAD ON LARGE DATASETS)
  getMachinesJumbo() {
    return this.http.get<Machine[]>(this.machineurl + "?_limit=-1", { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getMachines', [])));
  }

 
deleteMachine(id: number) {
  return this.http.delete(`${this.machineurl}/${id}`, {
    headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token })
  });
}

  //GET ALL MACHINE TYPES
  getTypes() {
    return this.http.get<Machinetype[]>(this.machinetypesurl, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getMachinesTypes', [])));
  }

  //GET MACHINE BY ID
  getMachine(id: number) {
    const url = `${this.machineurl}/${id}`;
    return this.http.get<Machine>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(data => { }), catchError(this.handleError<Machine>(`getMachine id=${id}`)));
  }


  //GET MACHINE BY SHORTNAME
  getMachineByShortname(criteria: string, shortname: string, client: number) {
    const url = this.machineurl + "?" + criteria + "_contains=" + shortname;
    return this.http.get<Machine[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('geMachineByShortname', [])));
  }

  //GET MACHINES COUNT WITH STATE AND CLIENT AS FILTER 
  getMachinesCount(state?: number, client?: number): Observable<number> {
    let params = new HttpParams();
    if (state !== undefined) params = params.set('state', state.toString());
    if (client !== undefined) params = params.set('client', client.toString());
    return this.http.get<number>(`${this.machineurl}/count`, {
      headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }),
      params: params  // ✅ Automatically adds filters dynamically
    }).pipe(
      catchError(this.handleError<number>('getMachinesCount', 0))
    );
  }

  //GET MACHINE BY VARIABLE CRITERIA - WILL SET LIMIT TO GRAPHQL LIMIT = 200
  getMachineByCriteria(criteria: string, cvalue: string, client: number, jwt: string) {
    const url = environment.graphURL + "{machines (where:{client:" + client + "," + criteria + "_contains:\"" + cvalue + "\"}){id shortname dispatched serialnumber modelnumber state{statevalue} counter location {addr1} machinetype{type imageurl} client{id name address }}}";
    return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + jwt }) }).pipe(map(data => data['data']['machines']));
  }

  //GET MACHINE BY CRITERIA WITH ADMIN PRIVELEGES
  getMachineByCriteriaAdmin(criteria: string, cvalue: string, jwt: string) {
    const url = environment.graphURL + "{machines (where:{" + criteria + "_contains:\"" + cvalue + "\"}){id dispatched shortname serialnumber modelnumber state{statevalue} location{addr1} machinetype{type imageurl}  counter client{id name address }}}";
    return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + jwt }) }).pipe(map(data => data['data']['machines']));
  }

  //GET MACHINES GROUPED BY LOCATION OR RANDOM CRITERIA AS ADMINISTRATOR
  getMachineByLocationIdAdmin(criteria: string, cvalue: string, jwt: string) {
    const url = environment.graphURL + "{machines (where:{" + criteria + ":\"" + cvalue + "\"}){id dispatched shortname serialnumber modelnumber counter state{statevalue} machinetype{type imageurl} location {addr1} client{id name address }}}";
    return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + jwt }) }).pipe(map(data => data['data']['machines']));
  }

  //GET MACHINE BY CLIENT AND LOCATION OR OTHER CRITERIA
  getMachineByLocationId(criteria: string, cvalue: string, client: number, jwt: string) {
    const url = environment.graphURL + "{machines (where:{client:" + client + "," + criteria + ":\"" + cvalue + "\"}){id dispatched shortname serialnumber modelnumber counter state{statevalue} location {addr1}client{id name address }}}";
    return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + jwt }) }).pipe(map(data => data['data']['machines']));
  }

  //RETURNS TRUE OR FALSE IF DEVICE IS IN DISPACH ALREADY
  isDispatched(id: number): boolean {
    console.log("We entered isDispatched");
    console.log("The id is :" + id);

    try {
      var mc: Machine;
      mc = new Machine;
      this.getMachine(id).subscribe(resp => {
        mc = resp;
        console.log(resp); console.log(mc.dispatched);
        return (mc.dispatched);
      })
    }
    catch { return false }
  }
  //GETS ALL USERS MACHINES. WILL LIMIT TO GRAPHQL LIMIT = 200
  getUserMachines(id: number, jwt: string) {
    const url = environment.graphURL + "{machines (where:{ user:\"" + id + "\"}){ user{username firstname lastname} observer{username firstname lastname} id machines { id shortname} title details  comments {user{username avatar{url}} postedon content}attachment{id url} status{id status}}}";
    return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + jwt }) }).pipe(map(data => data['data']['tickets']));
  }

  //GET MACHINES OF 1 CLIENT BY CLIENT ID
  getClientMachines(clientId: number) {
    var query = "{machines (where:{ client:" + clientId + "}){ client{name} id shortname  serialnumber modelnumber state{statevalue} location {addr1} state{id statevalue}}}"
    const url = environment.graphURL + query;
    return this.http.get<Machine[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['machines']));
  }

  //UPDATE MACHINE COUNTER
  updateMachineCounter(id: number, counter: number): Observable<any> {
    let upd = "{\"counter\":\"" + counter + "\"}";
    var urlcommand = this.machineurl + "/" + id;
    return this.http.put(urlcommand, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }

  //CHANGE MACHINE STATE
  changeState(machineId: number, stateID: number) {
    var upd = this.statusStr(stateID);
    var urlcommand = this.machineurl + "/" + machineId;
    return this.http.put(urlcommand, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }
  //RETURN STATUS 
  statusStr(id: number): string {
    return "{\"state\":\"" + id + "\" }";
  }

  //CHANGE IF MACHINE IS DISPATCHED OR NOT TRUE/FALSE
  changeDispatch(id: number, distpatched: boolean) {
    var upd = "{\"dispatched\":\"" + distpatched + "\" }";
    var urlcommand = this.machineurl + "/" + id;
    return this.http.put(urlcommand, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }

  //CREATE 1 MACHINE
  createMachine(newmachine: MachineCreate) {
    var upd = JSON.stringify(newmachine);
    return this.http.post<Machine>(`${environment.appURL}/machines/`, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }

  //GREATE BULK MACHINES USING ENHANCED METHOD
  createMachinesInBulk(machines: MachineCreate[]): Observable<any> {
    return this.http.post(
      this.machineurl + "/bulk",
      machines,
      { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) }  // Pass headers as the third argument
    );
  }


  //ERROR HANDLER
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}